<template>
    <div>
        <!-- Loan Summary -->
        <b-card no-body class="p-3">
            <b-row>
                <b-col cols="12">
                    <b-table-simple borderless class="legal-fees-calculator">
                        <b-tbody>
                            <b-tr>
                                <b-td class="title">Total Loan Amount</b-td>
                                <b-td class="value">RM {{ legalFees.loan_amount | moneyFormatter }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td class="title">Total Cost</b-td>
                                <b-td class="value">RM {{ legalFees.total_cost | moneyFormatter }}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-col>
            </b-row>
        </b-card>

        <!-- Sale & Purchase Agreement Costs -->
        <b-card no-body class="p-3">
            <b-row>
                <b-col cols="12">
                    <h3>Sale &amp; Purchase Agreement Costs</h3>
                </b-col>
                <b-col cols="12">
                    <b-table-simple borderless class="legal-fees-calculator">
                        <b-tbody>
                            <b-tr>
                                <b-td class="title">SPA Legal Fees</b-td>
                                <b-td class="value">RM {{ spaCost.spa_legal_fee | moneyFormatter }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td class="title">Reimbursement</b-td>
                                <b-td class="value">RM {{ spaCost.rembursement | moneyFormatter }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td class="title">Stamp Duty</b-td>
                                <b-td class="value">RM {{ spaCost.stamp_duty | moneyFormatter }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td class="title">Subtotal</b-td>
                                <b-td class="value">RM {{ spaCost.sub_total | moneyFormatter }}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-col>
            </b-row>
        </b-card>

        <!-- Loan Documentation Costs -->
        <b-card no-body class="p-3">
            <b-row>
                <b-col cols="12">
                    <h3>Loan Documentation Costs</h3>
                </b-col>
                <b-col cols="12">
                    <b-table-simple borderless class="legal-fees-calculator">
                        <b-tbody>
                            <b-tr>
                                <b-td class="title">Loan Legal Fees</b-td>
                                <b-td class="value">RM {{ loanCost.loan_legal_fee | moneyFormatter }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td class="title">1st party / 3rd party charge<br> Annexure (10% of Facility Agreement)</b-td>
                                <b-td class="value">RM {{ loanCost.charge_anexure_amount | moneyFormatter }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td class="title">Entry &amp; Withdrawal of Private Caveat</b-td>
                                <b-td class="value">RM {{ loanCost.entry_withdraw_caveat | moneyFormatter }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td class="title">Statutory Declaration</b-td>
                                <b-td class="value">RM {{ loanCost.statutory_declaration | moneyFormatter }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td class="title">Reimbursement</b-td>
                                <b-td class="value">RM {{ loanCost.rembursement | moneyFormatter }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td class="title">SST (6%)</b-td>
                                <b-td class="value">RM {{ loanCost.sst_tax | moneyFormatter }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td class="title">Disbursement</b-td>
                                <b-td class="value">RM {{ loanCost.disbursement | moneyFormatter }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td class="title">Loan Stamp Duty</b-td>
                                <b-td class="value">RM {{ loanCost.loan_stamp_duty | moneyFormatter }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td class="title">Subtotal</b-td>
                                <b-td class="value">RM {{ loanCost.sub_total | moneyFormatter }}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>
<script>
export default {
    props: {
        legalFees: Object,
    },
    data() {
        return {
            spaCost: {},
            loanCost: {}
        }
    },
    watch: {
        legalFees: {
        handler(newData) {
                // Update the data properties when mortgageData changes
                this.spaCost = newData.spa_cost
                this.loanCost = newData.loan_cost
            },
            immediate: true, // Trigger the handler immediately when the component is created
        },
    },
}
</script>